import { motion } from "framer-motion";
import {
  SunShape,
  CloudShape,
  Tree,
  Cone,
  TrafficLight,
  LPlateSign,
  PinPoint,
  ArrowSign,
  CarBody,
  Sparkle,
} from "./parts";

export const RoadBanner = () => (
  <div
    data-testid="about-illustration"
    className="relative overflow-hidden rounded-3xl border border-slate-200/80 bg-[#EAF3FF] shadow-xl shadow-blue-600/5"
  >
    <svg
      viewBox="0 0 1200 420"
      className="h-64 w-full md:h-96"
      preserveAspectRatio="xMidYMid slice"
      role="img"
      aria-label="Cartoon illustration of a learner car driving down an open road toward the horizon"
    >
      <g transform="translate(1080 85) scale(0.9)">
        <motion.g
          animate={{ rotate: 360 }}
          transition={{ duration: 70, repeat: Infinity, ease: "linear" }}
        >
          <SunShape />
        </motion.g>
      </g>
      <g transform="translate(180 75)">
        <motion.g
          animate={{ x: [0, 20, 0] }}
          transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
        >
          <CloudShape />
        </motion.g>
      </g>
      <g transform="translate(560 50) scale(0.8)">
        <motion.g
          animate={{ x: [0, -16, 0] }}
          transition={{ duration: 13, repeat: Infinity, ease: "easeInOut" }}
        >
          <CloudShape />
        </motion.g>
      </g>
      <g transform="translate(880 95) scale(0.6)">
        <motion.g
          animate={{ x: [0, 12, 0] }}
          transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
        >
          <CloudShape />
        </motion.g>
      </g>

      <ellipse cx="180" cy="440" rx="330" ry="115" fill="#BBF7D0" />
      <ellipse cx="1030" cy="450" rx="350" ry="125" fill="#A7F3D0" />

      <path d="M0 420 L470 205 L730 205 L1200 420 Z" fill="#64748B" />
      <path d="M470 205 L0 420" stroke="#F8FAFC" strokeWidth="5" fill="none" />
      <path d="M730 205 L1200 420" stroke="#F8FAFC" strokeWidth="5" fill="none" />
      <path
        className="road-dash"
        d="M600 215 L600 420"
        stroke="#FFFFFF"
        strokeWidth="7"
        strokeDasharray="24 28"
        strokeLinecap="round"
        fill="none"
      />

      <g transform="translate(60 190) scale(0.8)">
        <TrafficLight x={0} y={0} />
      </g>
      <LPlateSign x={170} y={195} />
      <ArrowSign x={995} y={215} />
      <Tree x={1115} y={295} scale={1.1} />
      <Cone x={415} y={318} scale={0.9} />
      <Cone x={792} y={328} scale={0.95} />
      <PinPoint x={648} y={100} />

      <g transform="translate(505 235) scale(0.78)">
        <motion.g
          animate={{ y: [0, -4, 0] }}
          transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
        >
          <CarBody />
        </motion.g>
      </g>

      <Sparkle x={320} y={120} />
      <Sparkle x={940} y={150} delay={1} />
    </svg>
  </div>
);
